module.exports = __webpack_public_path__ + "static/media/smartmirror-hardware.2845a08e.jpeg";